<template>
    <div class="content" style="margin-top: 1%;">
        <div class="elegant-section-divider mt-5 mb-4">
            <span class="divider-text">NUESTRAS MARCA</span>
        </div>
        <div v-if="selectedMarca !== null" class="brand-explorer-card shadow-sm">
            <div class="row m-0 w-100">
                <div class="col-md-3 brand-sidebar-info p-4">
                    <div class="text-center mb-4">
                        <div v-if="loading" class="skeleton-img mb-3 mx-auto" style="width: 150px; height: 80px;"></div>
                        <img v-else :src="getAbsoluteImageUrl('/img/marcas/' + marcas[selectedMarca].name + '.webp')"
                            class="img-fluid mb-3" style="max-height: 80px;">
                        <div v-if="loading" class="py-2">
                            <div class="skeleton-text w-100 mb-2" style="height: 12px;"></div>
                        </div>
                        <p v-else class="brand-tagline text-uppercase mb-1">
                            {{ marcas[selectedMarca].descripcion }}
                        </p>

                        <!--<div v-if="loading" class="py-2">
                            <div class="skeleton-text w-100 mb-2" style="height: 12px;"></div>
                            <div class="skeleton-text w-75 mx-auto" style="height: 12px;"></div>
                        </div>
                        <p v-else class="brand-description-text small text-muted">{{ marcas[selectedMarca].descripcion
                        }}</p>-->
                    </div>

                    <div class="brand-stats-vertical">
                        <div class="stat-item-card d-flex align-items-center shadow-sm">
                            <i class='bx bx-box me-2'
                                :style="{ color: loading ? '#e2e8f0' : getColorByNumber(marcas[selectedMarca].color) }"></i>
                            <div class="w-100 text-start">
                                <div v-if="loading" class="skeleton-text w-50 mb-1" style="height: 18px;"></div>
                                <span v-else class="d-block fw-bold h6 mb-0">{{ marcaslineas.total_productos }}</span>
                                <small class="text-muted" style="font-weight: bold; font-size: 9px;">PRODUCTOS</small>
                            </div>
                        </div>

                        <div class="stat-item-card d-flex align-items-center shadow-sm mt-2">
                            <i class='bx bx-layer me-2'
                                :style="{ color: loading ? '#e2e8f0' : getColorByNumber(marcas[selectedMarca].color) }"></i>
                            <div class="w-100 text-start">
                                <div v-if="loading" class="skeleton-text w-50 mb-1" style="height: 18px;"></div>
                                <span v-else class="d-block fw-bold h6 mb-0">{{ marcaslineas.total_aplicaciones
                                }}</span>
                                <small class="text-muted"
                                    style="font-weight: bold; font-size: 9px;">APLICACIONES</small>
                            </div>
                        </div>
                        <div class="stat-item-card d-flex align-items-center shadow-sm mt-2"
                            v-if="marcaslineas.total_productos_compatibles > 0">

                            <i :class="!loading && marcaslineas.total_productos_compatibles > 0 ? 'bx bxs-car me-2' : 'bx bx-layer me-2'"
                                :style="{ color: loading ? '#e2e8f0' : (marcaslineas.total_productos_compatibles > 0 ? '#2e7d32' : getColorByNumber(marcas[selectedMarca].color)) }">
                            </i>

                            <div class="w-100 text-start">
                                <div v-if="loading" class="skeleton-text w-50 mb-1" style="height: 18px;"></div>
                                <template v-else>
                                    <span class="d-block fw-bold h6 mb-0">
                                        {{ marcaslineas.total_productos_compatibles || 0 }}
                                    </span>

                                    <small class="text-muted d-block"
                                        style="font-weight: bold; font-size: 9px; text-transform: uppercase; line-height: 1;">
                                        Productos para tu {{ detallesVehicle?.marca || 'Vehículo' }}
                                    </small>
                                </template>
                            </div>

                            <span v-if="!loading && marcaslineas.total_productos_compatibles > 0"
                                class="badge rounded-pill bg-success"
                                style="font-size: 8px; position: absolute; top: -5px; right: -5px;">
                                MATCH
                            </span>
                        </div>
                    </div>
                </div>

                <div class="col-md-9 p-0 d-flex flex-column brand-main-content"
                    :style="getBrandGradient(marcas[selectedMarca].color)">
                    <div class="brand-main-grid-scroll p-4">

                        <div v-if="loading" class="lines-grid-container">
                            <div v-for="n in 12" :key="'sk' + n" class="linea-card-v2 shadow-sm p-3 is-loading">
                                <div class="d-flex justify-content-center mb-2" style="height: 50px;">
                                    <div class="skeleton-img" style="width: 55px; height: 50px;"></div>
                                </div>
                                <div class="skeleton-text w-75 mx-auto mb-2" style="height: 12px;"></div>
                                <div class="skeleton-text w-50 mx-auto" style="height: 10px;"></div>
                            </div>
                        </div>

                        <div v-else class="lines-grid-container">
                            <router-link v-for="(linea, lineIndex) in marcaslineas.lineas" :key="lineIndex"
                                :to="{ name: 'ListadoProductos', query: { id: linea.id_linea, linea: linea.linea } }"
                                class="linea-card-v2 shadow-sm text-decoration-none">
                                <div class="mb-2 d-flex justify-content-center" style="height: 50px;">
                                    <img :src="linea.LineaPicturesUrl?.length > 0
                                        ? linea.LineaPicturesUrl[0]
                                        : '/img/display/Placeholder.png'" class="img-fluid"
                                        style="height: 50px; object-fit: contain;" alt="Imagen de línea">
                                </div>
                                <span class="linea-name">{{ linea.linea }}</span>
                                <span class="linea-count">{{ linea.productos_count }} Productos</span>
                                <span class="linea-count">{{ linea.total_aplicaciones }} Aplicaciones</span>
                                <span class="linea-count" v-if="linea.productos_compatibles_count > 0">
                                    <i class="bx bxs-check-shield"></i>
                                    {{ linea.productos_compatibles_count }} piezas para tu {{ vehiculoSeleccionado.marca
                                    }}
                                </span>
                            </router-link>
                        </div>
                    </div>

                    <!--<div class="text-end p-3 bg-white border-top mt-auto">
                        <div v-if="loading" class="skeleton-text ms-auto"
                            style="width: 250px; height: 35px; border-radius: 50px;"></div>
                        <router-link v-else to="/" class="btn-ver-todo mt-0">
                            Ver Todo el Catálogo de {{ marcas[selectedMarca].name }} <i
                                class='bx bx-right-arrow-alt'></i>
                        </router-link>
                    </div>-->
                </div>

            </div>
        </div>

        <div class="brand-footer-selector mt-4 text-center">
            <div class="d-flex justify-content-center align-items-center gap-3 bg-white p-3 rounded-pill shadow-sm mx-auto"
                style="width: fit-content; min-width: 300px;">

                <template v-if="marcas.length === 0 || loadingmarcas">
                    <div v-for="n in 5" :key="'sk-footer-' + n" class="skeleton-img rounded-circle"
                        style="width: 35px; height: 35px;">
                    </div>
                </template>

                <template v-else>
                    <div v-for="(marca, index) in marcas" :key="index" @click="showMarcaInfo(index, marca.id)"
                        style="cursor: pointer;" :class="{ 'selected-brand': index === selectedMarca }">
                        <img :src="getAbsoluteImageUrl('/img/marcas/' + marca.name + '.webp')"
                            style="height: 30px; filter: grayscale(1); transition: 0.3s;"
                            :style="index === selectedMarca ? 'filter: grayscale(0); transform: scale(1.1);' : ''">
                    </div>
                </template>

            </div>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            marcas: {},
            activeListIndex: null,
            isMenuActive: false,
            selectedMarca: null,
            marcaslineas: [],
            loading: false,
            loadingmarcas: false


        };
    },
    methods: {
        getColorByNumber(number) {
            //console.log(number)
            switch (number) {
                case 'red':
                    return '#cf0a0a !important'; // Rojo
                case 'amarillo':
                    return '#ffc340 !important'; // Amarillo
                case 'blue':
                    return '#cf2a2a !important'; // Azul claro

                case 'plata':
                    return '#6b7d71 !important'; // Plata
                case 'red2':
                    return '#06283c !important'; // Otro color
                default:
                    return ''; // Por defecto, no se aplica ningún color
            }
        },
        getBrandGradient(colorName) {
            const colors = {
                'red': 'rgba(255, 0, 0, 0.18)',        // Rojo más vivo
                'red2': 'rgba(220, 20, 60, 0.18)',     // Carmesí reforzado
                'amarillo': 'rgba(255, 193, 7, 0.22)', // Ámbar más presente
                'blue': 'rgba(28, 163, 223, 0.18)',    // El azul cian que te gusta
                'plata': 'rgba(148, 163, 184, 0.25)'   // Plata con un toque más metálico (slate-400)
            };

            // Fallback un poco más azulado para que no se vea "muerto" si no hay color
            const baseColor = colors[colorName] || 'rgba(226, 232, 240, 0.5)';

            return {
                // Cambiamos el 0% por un rango (ej. hasta el 20%) para que el color sature un poco más al inicio
                'background-image': `linear-gradient(145deg, ${baseColor} 0%, rgba(248, 251, 255, 0.3) 40%, #f8fbff 100%)`,
                'background-color': '#f8fbff',
                'transition': 'all 0.6s ease-in-out'
            };
        },

        showMarcaInfo(index, id) {
            if (this.selectedMarca === index) {
                this.selectedMarca = null;
                this.marcaslineas = [];
                return;
            }
            this.selectedMarca = index;
            this.loading = true;

            axios.get(`/getMarcaDetails/${id}`).then((response) => {
                this.marcaslineas = response.data;
            })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false; // Oculta el spinner
                });
        },
        getOverflowYStyle(lineas) {
            return lineas && lineas.length > 5 ? 'auto' : 'hidden';
        },

        handleNavTriggerClick(index) {
            this.activeListIndex = this.activeListIndex === index ? null : index;
            this.isMenuActive = this.activeListIndex !== null;
            if (this.marcas[index]) {
                this.marcas[index].showScrollList = !this.marcas[index].showScrollList;
            }
            //console.log(this.marcas)
        },

        shouldEnableScroll(lineas) {
            return lineas && lineas.length > 6;
        },
        getContainerClass(marca) {
            const colorClass = `container container--${marca.color}`;
            const overflowClass = marca.lineas.length > 5 ? 'container--with-overflow' : '';
            return `${colorClass} ${overflowClass}`;
        },

        MarcasHome() {
            this.loadingmarcas = true;

            axios.get('/shark')
                .then((response) => {
                    // 1. Mapeamos los datos
                    this.marcas = response.data.map((marca) => ({
                        ...marca,
                        showScrollList: false,
                    }));

                    // 2. Si hay marcas, seleccionamos la primera por default (index 0)
                    if (this.marcas.length > 0) {
                        const primeraMarca = this.marcas[0];
                        this.showMarcaInfo(0, primeraMarca.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingmarcas = false;
                });
        },

        getAbsoluteImageUrl(relativeUrl) {
            // Obtén la URL base de Laravel
            const baseUrl = window.location.origin;

            // Concatena la URL base con la ruta relativa de la imagen
            return baseUrl + relativeUrl;
        },
        destroy() {
            // Limpiar arrays u objetos
            this.marcas = {};
            this.marcaslineas = [];
            this.autoplayInterval = undefined;
            // Limpiar otros recursos si es necesario
        }
    },
    watch: {
        isMenuActive(newValue) {
            const menuContainer = document.querySelector('.menu-container');
            if (menuContainer) {
                if (newValue) {
                    menuContainer.classList.add('active');
                } else {
                    setTimeout(() => {
                        menuContainer.classList.remove('active');
                    }, 500);
                }
            }
        },
    },
    mounted() {

        this.MarcasHome();

    },
    computed: {
        vehiculoSeleccionado() {
            return this.$store.getters.vehiculoSeleccionado;
        }
    },
    beforeUnmount() {
        this.destroy();
    },
}   
</script>
<style scoped>
.elegant-section-divider {
    display: flex;
    align-items: center;
    text-align: center;
    width: 100%;
    margin-top: 3rem;
    /* Espaciado superior para separar de la card principal */
}

/* Las "líneas" a los lados del texto */
.elegant-section-divider::before,
.elegant-section-divider::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #eef2f6;
    /* El mismo gris claro de tus bordes */
}

/* El texto centrado */
.divider-text {
    padding: 0 20px;
    /* Espacio alrededor del texto para que no toque las líneas */
    font-size: 1.25rem;
    /* Pequeño, como en la imagen */
    font-weight: 800;
    /* Muy negrita */
    color: #06283c;
    /* Tu color azul oscuro principal */
    letter-spacing: 1.5px;
    /* Espaciado entre letras para ese toque premium */
    text-transform: uppercase;
    /* Siempre en mayúsculas */
    background-color: #f8fbff;
    /* ¡CRÍTICO! Debe ser el color exacto del fondo de tu página */
    position: relative;
    z-index: 1;
}

.brand-main-content {
    /* Asegura que ocupe todo el alto y permita ver el gradiente */
    min-height: 100%;
    position: relative;
    z-index: 1;
}

/* Contenedor Principal (Blanco con sombra) */
.brand-explorer-card {
    background-color: #ffffff;
    border-radius: 15px;
    overflow: hidden;
    border: 1px solid #eef2f6;
    margin: 20px auto;
    display: flex;
    max-width: 1200px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
}

/* Sidebar Izquierda (Fondo con degradado sutil) */
.brand-sidebar-info {
    flex: 0 0 280px;
    border-right: 1px solid #edf2f7;
    padding: 30px 20px;
}

/* Títulos y textos del Sidebar */
.brand-tagline {
    font-size: 10px;
    font-weight: 800;
    color: #1ca3df;
    letter-spacing: 0.5px;
}

.brand-description-text {
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
}

/* Cards de Stats (Productos/Aplicaciones) */
.stat-item-card {
    background: white;
    border-radius: 8px;
    padding: 10px 15px;
    margin-bottom: 10px;
    border: 1px solid #e2e8f0;
}

.stat-item-card i {
    font-size: 24px;
    margin-right: 12px;
}


.brand-main-grid-scroll {
    flex: 1;
    max-height: 480px;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Grid de 4 columnas */
.lines-grid-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 15px;
}

/* Personalización del Scroll */
.brand-main-grid-scroll::-webkit-scrollbar {
    width: 6px;
}

.brand-main-grid-scroll::-webkit-scrollbar-track {
    background: transparent;
}

.brand-main-grid-scroll::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
}

.brand-main-grid-scroll::-webkit-scrollbar-thumb:hover {
    background: #1ca3df;
}

/* Botón Ver Todo */
.btn-ver-todo {
    display: inline-block;
    color: #ff9900;
    border: 1px solid #ff9900;
    padding: 8px 25px;
    border-radius: 50px;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    transition: 0.3s;
    background: white;
}

.btn-ver-todo:hover {
    background: #ff9900;
    color: white;
}

/* Card de cada Línea */
.linea-card-v2 {
    background: white;
    border-radius: 10px;
    padding: 20px 10px;
    text-align: center;
    border: 1px solid transparent;
    transition: all 0.3s ease;
    text-decoration: none !important;
}

.linea-card-v2:hover {
    border-color: #1ca3df;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transform: translateY(-3px);
}

.linea-card-v2 img {
    height: 45px;
    width: auto;
    margin-bottom: 12px;
    object-fit: contain;
}

.linea-name {
    display: block;
    font-size: 12px;
    font-weight: 800;
    color: #06283c;
    text-transform: uppercase;
}

.linea-count {
    display: block;
    font-size: 11px;
    color: #94a3b8;
}

/* Selector de Marcas Inferior */
.brand-footer-selector {
    display: flex;
    justify-content: center;
    gap: 20px;
    background: white;
    border-radius: 50px;
    width: fit-content;
    margin: 0 auto;
    border: 1px solid #e2e8f0;
}

/* --- BASE DEL SKELETON (SHIMMER EFFECT) --- */
.skeleton-img,
.skeleton-text {
    background: #f2f4f6;
    /* Gradiente de 3 puntos para el efecto de brillo */
    background-image: linear-gradient(90deg,
            #f2f4f6 25%,
            #e2e8f0 50%,
            #f2f4f6 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite ease-in-out;
    border-radius: 6px;
    display: block;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

/* --- AJUSTES ESPECÍFICOS --- */
.linea-card-v2.is-loading {
    pointer-events: none;
    border: 1px solid #f1f5f9;
}

.rounded-circle.skeleton-img {
    border-radius: 50% !important;
}

/* Helpers de ancho */
.w-25 {
    width: 25% !important;
}

.w-50 {
    width: 50% !important;
}

.w-75 {
    width: 75% !important;
}

.w-100 {
    width: 100% !important;
}

@media (max-width: 768px) {
    .brand-explorer-card {
        flex-direction: column;
        /* Cambia de fila a columna */
        margin: 10px;
        border-radius: 10px;
    }

    .brand-sidebar-info {
        flex: 1 1 auto;
        /* Quita el ancho fijo de 280px */
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #edf2f7;
        /* Línea divisoria ahora horizontal */
        padding: 20px;
    }
}

@media (max-width: 992px) {
    .lines-grid-container {
        grid-template-columns: repeat(3, 1fr);
        /* 3 columnas en laptops pequeñas */
    }
}

@media (max-width: 768px) {
    .lines-grid-container {
        grid-template-columns: repeat(2, 1fr);
        /* 2 columnas en tablets/celulares */
        gap: 10px;
    }

    .brand-main-grid-scroll {
        max-height: none;
        /* Dejamos que crezca según el contenido en móvil */
    }

    .brand-footer-selector {
        width: 95%;
        /* Ocupa casi todo el ancho */
        overflow-x: auto;
        /* Permite scroll lateral si hay muchas marcas */
        justify-content: flex-start;
        /* Alinea al inicio para el scroll */
        padding: 10px 20px;
        border-radius: 20px;
        /* Menos redondeado para ahorrar espacio */
        gap: 15px;
    }

    /* Ocultar la barra de scroll del selector para que se vea limpio */
    .brand-footer-selector::-webkit-scrollbar {
        display: none;
    }

    .divider-text {
        font-size: 0.9rem;
        /* Texto un poco más pequeño en el divisor */
        padding: 0 10px;
    }
}

@media (max-width: 480px) {
    .lines-grid-container {
        grid-template-columns: repeat(2, 1fr);
        /* Mantener 2 es mejor que 1 para no hacer scroll infinito */
    }

    .linea-card-v2 {
        padding: 15px 5px;
    }
}

@media (max-width: 576px) {
    .brand-tagline {
        font-size: 9px;
    }

    .brand-description-text {
        font-size: 11px;
    }

    .btn-ver-todo {
        width: 100%;
        /* Botón ancho total en móviles pequeños */
        text-align: center;
    }
}
</style>